import { AUTO_DETECT_LOCALE, DEFAULT_LOCALE, LOCALE_STORAGE_KEY } from './config';
import { isSupportedLocale } from './languages';

/**
 * Gespeicherte Sprachwahl lesen.
 * Reihenfolge: localStorage → (optional) Browsersprache → DEFAULT_LOCALE.
 * Wirft nie — im Zweifel Deutsch.
 */
export function readStoredLocale(): string {
  try {
    const saved = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (isSupportedLocale(saved)) return saved as string;

    if (AUTO_DETECT_LOCALE && typeof navigator !== 'undefined') {
      const nav = (navigator.language || '').split('-')[0];
      if (isSupportedLocale(nav)) return nav;
    }
  } catch {
    /* localStorage blockiert (Privatmodus) → Vorgabe */
  }
  return DEFAULT_LOCALE;
}

/** Sprachwahl speichern. Gibt false zurück, wenn das Speichern scheitert. */
export function writeStoredLocale(code: string): boolean {
  if (!isSupportedLocale(code)) return false;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
    return true;
  } catch {
    return false;
  }
}

/** <html lang="..."> setzen — für Screenreader, Rechtschreibprüfung und CSS. */
export function applyDocumentLang(code: string): void {
  try {
    document.documentElement.lang = code;
  } catch {
    /* SSR/Testumgebung */
  }
}
